export default __webpack_public_path__ + "static/media/xlsxThumbnail.87998853.svg";